import React from 'react';
import { FaCheck, FaUserCheck, FaUserTimes, FaDesktop, FaMobileAlt } from 'react-icons/fa';

export function formatSQLDateTime(sqlDateTime) {
    // Format SQL date time objects as local date time (PST)
    var jsDateTime = new Date(sqlDateTime);
    return jsDateTime.toLocaleString();
}

export function displayUserAuthAuthorized(bool) {
    // Display the proper icon if a user was allowed access to remote learning center
    // eslint-disable-next-line
    return (bool == true) ? <FaUserCheck size='1.2em' color='green' /> : <FaUserTimes size='1.2em' color='red'/>
}

export function displayEmailVerified(bool) {
    // Display a green check if member's email is verified
    // eslint-disable-next-line
    return (bool == true) ? <FaCheck color='green' /> : '';
}

export function displayAffiliateNumber(value) {
    // Properly display the member's affiliate number
    return (value) ? value : "Default"
}

export function displayDeviceType(type) {
    // Display the device type as the proper icon
    switch(type) {
        case 'phone':
            return <FaMobileAlt size='1.2em' />
        case 'desktop':
            return <FaDesktop size='1.2em' />
        case 'tablet':
            return 'Tablet';
        default:
            return type;
    }
}

export function navigateToMemberDetail(id) {
    // Navigate to the detailed member screeen
    return window.location.href = `/admin/member?id=${id}`;
}

export function navigageToVideoAnalyticsDetail(video_uri) {
    // Navigate to the detailed member screeen
    return window.location.href = `/admin/analytics/video?uri=${video_uri}`;
}